import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { selectCurrentEmpid, selectCurrentUser } from '../../../pages/login/authSlice';
import { useGetTeamLeadScoreCardsQuery } from '../../../pages/scorecardDashboard/scorecardDashboardSlice';
import { ConstApplicationRole } from '../../../utils/typeConstants';
import { saveSCfilDate } from '../../../utils/dateStorage';

interface PropTypes {
    setAgentNumber: (e: number) => void;
    scorecardVersionValue: (e: number) => void;
    inputmonth: number;
    setInputMonth: (e: number) => void;
    inputyear: number;
    setInputYear: (e: number) => void;
    date: Date;
    setDate: (e: Date) => void;
}

const FilterAgentScoreCard = ({
    scorecardVersionValue,
    setAgentNumber,
    inputmonth,
    setInputMonth,
    inputyear,
    setInputYear,
    date,
    setDate,
}: PropTypes) => {
    const [scorecardDisable, setScorecardDisable] = useState<boolean>(false);
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const empNum = useSelector(selectCurrentEmpid);
    const loggedUser = useSelector(selectCurrentUser);
    const { scid, tldate } = useParams();

    const { data: teamLeadScoreCardsDataValue } = useGetTeamLeadScoreCardsQuery(
        {
            employeenumber: empNum,
            year: inputyear,
            month: inputmonth,
            applicationRoleId: ConstApplicationRole.TEAM_LEAD,
        },
        { skip: !empNum }
    );

    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        setDate(e.value);
        setInputMonth(e.value.getMonth() + 1);
        setInputYear(e.value.getFullYear());
        saveSCfilDate(e.value);
        window.localStorage.TLscorecardVersion = '';
        scorecardVersionValue(0);
    };

    useEffect(() => {
        setAgentNumber(empNum);
        if (teamLeadScoreCardsDataValue?.data.length > 0) {
            window.localStorage.EnableAddDispute = 'true';
            setScorecardDisable(false);
            if (window.localStorage.TLscorecardVersion) {
                setScorecardVersion(parseInt(window.localStorage.TLscorecardVersion, 10));
                scorecardVersionValue(parseInt(window.localStorage.TLscorecardVersion, 10));
            } else {
                setScorecardVersion(teamLeadScoreCardsDataValue?.data[0].scorecard_version_id);
                scorecardVersionValue(teamLeadScoreCardsDataValue?.data[0].scorecard_version_id);
            }
        } else {
            window.localStorage.EnableAddDispute = 'false';
            setScorecardDisable(true);
        }
    }, [teamLeadScoreCardsDataValue]);

    const ScorecardOnChange = (e: any) => {
        setScorecardVersion(e.value);
        scorecardVersionValue(e.value);
        window.localStorage.TLscorecardVersion = e.value;
    };

    useEffect(() => {
        if (tldate) {
            const storedDate = new Date(tldate);
            if (!isNaN(storedDate.getTime())) {
                setDate(storedDate);
                setInputMonth(storedDate.getMonth() + 1);
                setInputYear(storedDate.getFullYear());
                saveSCfilDate(storedDate);
            }
        }
        if (scid) {
            window.localStorage.TLscorecardVersion = scid;
        }

        // if (window.localStorage.TLDate) {
        //     const storedDate = new Date(window.localStorage.TLDate);
        //     if (storedDate) {
        //         setDate(storedDate);
        //         setInputMonth(storedDate.getMonth() + 1);
        //         setInputYear(storedDate.getFullYear());
        //     }
        // }
    }, []);

    return (
        <div className="card shadow bg-body rounded mt-3 border-0">
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-md-4 text-start">
                        <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                            {`Hello ${loggedUser}!`}
                        </span>
                    </div>
                    <div className="col-md-8 d-flex justify-content-end align-items-center gap-2">
                        <Calendar
                            value={date}
                            onChange={DateOnChange}
                            view="month"
                            maxDate={new Date()}
                            showIcon
                            className="custom-calendar me-4"
                            dateFormat="MM, yy"
                        />
                        <Dropdown
                            disabled={scorecardDisable}
                            value={scorecardVersion}
                            onChange={ScorecardOnChange}
                            options={teamLeadScoreCardsDataValue?.data}
                            optionValue={'scorecard_version_id'}
                            optionLabel={'scorecard_name'}
                            placeholder={'No Scorecards'}
                            className="custom-dropdown me-3"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterAgentScoreCard;
